export enum DragableType {
    Default = 'Default',
}

type DragableItemProps<T> = {
    item: T;
    originNode: React.ReactElement;
    moveItem: (hoveredItem: T | any) => void;
    setDragElement: (element: T) => void;
};

const DragableItem = <T,>({ item, originNode, moveItem, setDragElement }: DragableItemProps<T>) => {
    const onDragStart = (e: React.DragEvent<HTMLDivElement>) => {
        e.dataTransfer.setData(DragableType.Default, JSON.stringify(item));
        setDragElement(item);
        setTimeout(() => {
            (e.target as HTMLElement).style.visibility = 'hidden';
        }, 1);
    };

    const onDragOver = (e: React.DragEvent<HTMLDivElement>) => {
        moveItem(item);
        e.preventDefault();
    };

    const onDragEnd = (e: React.DragEvent<HTMLDivElement>) => {
        (e.target as HTMLElement).style.visibility = 'visible';
    };

    return (
        <div
            onDragEnd={onDragEnd}
            onDragOver={onDragOver}
            onDragStart={onDragStart}
            style={{ height: '100%' }}
            draggable
        >
            {originNode}
        </div>
    );
};

export default DragableItem;
